import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FlowManagerService } from '../../services/flow-manager.service';
import { swalMini, swalWarning } from '../../../../shared/utils/utils';
import { FormControl, Validators } from '@angular/forms';
import includes from 'lodash/includes';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';
import {ToastBannerService} from '../../../../shared/components/cms/toast-banner/toast-banner.service';

@Component({
  selector: 'app-rename-flow',
  templateUrl: './rename-flow.component.html',
  styleUrls: ['./rename-flow.component.scss'],
})
export class RenameFlowComponent implements OnInit {
  flowId: any;
  newFlowName = new FormControl('', [Validators.required]);
  flowPath: any;
  requestFlowLoad: string;
  requestRouteLoad: string;
  savingInProgress: Boolean = false;
  originalFlowName: string;

  constructor(
    public dialogRef: MatDialogRef<RenameFlowComponent>,
    private flowManagerService: FlowManagerService,
    private sharedService: SharedService,
    private toastService: ToastBannerService,
  ) {}

  ngOnInit() {
    this.flowId = this.dialogRef._containerInstance._config.data.flowId;
    this.flowPath = this.dialogRef._containerInstance._config.data.path;
    this.newFlowName = this.dialogRef._containerInstance._config.data.flowName;
    this.originalFlowName = Object.assign(this.dialogRef._containerInstance._config.data.flowName);
  }

  saveFlow() {
    const stageRequest = {
      flowId: this.flowId,
      flowPath: this.flowPath.concat(this.newFlowName),
      flowName: this.newFlowName,
    };

    if (includes(this.newFlowName, '/')) {
      this.displayBanner(
          '#F8BD32',
          'redesign/ExclamationMark.svg',
          `Enter flow name without /`,
          ``,
          false,
          true
      );
      return;
    }

    const sameName = this.sharedService.checkSameFlowName('rename', {
      flowId: this.flowId,
      flowName: this.newFlowName,
    });
    if (sameName) {
      this.displayBanner(
          '#F8BD32',
          'redesign/ExclamationMark.svg',
          `Flow with same name already exist!`,
          ``,
          false,
          true
      );
      return;
    }
    this.savingInProgress = true;
    this.flowManagerService.renameFlow(stageRequest).subscribe(
      (response) => {
        this.savingInProgress = false;
        this.dialogRef.close();
        if (response.result === true) {
          this.displayBanner(
              '#8cc63f',
              'redesign/Check_Mark_Filled.svg',
              `Flow successfully renamed.`,
              ``,
              false,
              true
          );
          this.flowManagerService.getFlows(true).subscribe((flows) => {
            this.sharedService.updateFlows(flows);
          });
          return;
        }
        swalWarning({ title: `Failed to rename flow!, (${response.message})` });
      },
      (err) => {
        this.savingInProgress = false;
        this.displayBanner(
            '#C23313',
            'redesign/ExclamationsMark_Red.svg',
            `${err.error.message}`,
            '',
            false,
            true
        );
      }
    );
  }

  canSaveFlow() {
    return this.newFlowName ? true : false;
  }

  closeModal() {
    this.dialogRef.close();
  }

  getErrorMessage() {
    return 'Please enter flow name.';
  }

  displayBanner(lineColor: string, icon: string, title: string, descrip: string, bigIcon: boolean, closeIcon: boolean): void {
    this.toastService.setBannerParams({ lineColor, icon, title, descrip, bigIcon, closeIcon });
    setTimeout(() => {
      this.toastService.clearBannerParams();
    }, 5000);
  }

}
